import { getRequestConfig } from './index';

export const passKeysApi = (path: string, body?: unknown) => {
  const config = getRequestConfig();
  return fetch(`/json/api/auth/passkeys${path}`, {
    method: 'POST',
    credentials: 'include',   // send session cookie
    ...config,
    body: body ? JSON.stringify(body) : undefined,
  });
};
